import { requestHttp } from '@/utils';

const SERVER = ``;

/**
 * 方案清单详情类型定义
 *
 * **接口文档** 黄冰洋<huangbingyang@lysoratech.com>
 *
 * [方案清单](https://enetdevtest.rj.link/api/v1/schemes/doc.html#/default/%E6%96%B9%E6%A1%88%E7%AB%A0%E8%8A%82/getSectionUsingGET) - https://enetdevtest.rj.link/api/v1/schemes/doc.html#/default/%E6%96%B9%E6%A1%88%E7%AB%A0%E8%8A%82/getSectionUsingGET
 *
 * @typedef { object } ChecklistDetail
 * @property { string | number } id 方案章节ID
 * @property { string | number } schemeId 所属方案ID
 * @property { object } sectionContent 方案清单具体内容
 * @property { ChecklistProductList } [sectionContent.prodList] 方案清单产品列表
 * @property { ChecklistFloorList } [sectionContent.regionList] 方案清单楼层列表
 * @property { number } sectionContent.taxRate 税点
 * @property { 0 | 10 } sectionContent.toSomeone 方案报价对象（渠道用户可选），默认 **给工程商报价**
 * - 0 - 给业主报价
 * - 10 - 给工程商报价
 * @property { number } [sectionContent.totalPrice] **给业主报价调整后的总价**，有值则始终使用该值，未返回时则前端自行计算总价
 * @property { ChecklistWireList } sectionContent.wireList - 方案清单线材列表
 * @property { string } sectionName 方案清单名称，固定 **产品清单**
 * @property { number } sectionOrder 排序（目前没用）
 * @property { 'prodList' } sectionType 类型，方案清单固定 **proList**
 * @property { 0 | 1 } sectionVisible 是否可见（目前没用）
 */

/**
 * 方案清单产品详情类型定义
 *
 * **接口文档** 黄冰洋<huangbingyang@lysoratech.com>
 *
 * [方案清单](https://enetdevtest.rj.link/api/v1/schemes/doc.html#/default/%E6%96%B9%E6%A1%88%E7%AB%A0%E8%8A%82/getSectionUsingGET) - https://enetdevtest.rj.link/api/v1/schemes/doc.html#/default/%E6%96%B9%E6%A1%88%E7%AB%A0%E8%8A%82/getSectionUsingGET
 *
 * @typedef { object } ChecklistProductDetail
 * @property { number } addMethod 添加方式（目前值等未知）
 * @property { string } brandName 品牌名称，如 **Lysora**
 * @property { number } catId 产品分类ID
 * @property { string } catName 产品分类名称
 * @property { string } catTag 产品分类英文Tag
 * @property { number } costPrice 产品成本价
 * @property { number } devicePosition
 * @property { number } deviceVisible
 * @property { ChecklistDeviceList } devices 型号设备列表
 * @property { boolean } hasBridgeProd 是否包含网桥地勘的设备，主要用于海外云地勘判断是否可以替换
 * @property { number } id 产品列表ID
 * @property { boolean } isWire 是否线材，目前普通产品和线材分开返回，所以产品详情该字段固定 `false`
 * @property { string } notes 备注
 * @property { number } originalCostPrice
 * @property { number } originalProdPrice
 * @property { number } prodCount
 * @property { number } prodCountView
 * @property { string } prodDescp 产品型号说明
 * @property { number } prodId 产品型号ID
 * @property { string } prodIntro 产品型号简介
 * @property { string } prodKey
 * @property { string } prodName 产品型号名称
 * @property { number } prodPrice 产品售价
 * @property { string } prodSource 产品型号来源，如 `lysora`，标识为Lysora产品
 * @property { string } prodUnit 产品型号单位，如 `台`
 * @property { string } productSource 产品型号来源，如 `lysora`，标识为Lysora产品
 * @property { number } [regionId] 楼层ID，当 **按楼层查看时** 返回
 * @property { string } [regionName] 楼层名称，当 **按楼层查看时** 返回
 * @property { string } resourseUrl 来源图标链接地址
 * @property { number } schemeId 产品归属方案ID
 * @property { number } schemeProdOrder
 * @property { string } typeName 产品Tag
 * @property { number } unitCount
 * @property { number } userProdCount
 */

/**
 * 方案清单产品列表类型定义
 *
 * **接口文档** 黄冰洋<huangbingyang@lysoratech.com>
 *
 * [方案清单](https://enetdevtest.rj.link/api/v1/schemes/doc.html#/default/%E6%96%B9%E6%A1%88%E7%AB%A0%E8%8A%82/getSectionUsingGET) - https://enetdevtest.rj.link/api/v1/schemes/doc.html#/default/%E6%96%B9%E6%A1%88%E7%AB%A0%E8%8A%82/getSectionUsingGET
 *
 * @typedef { ChecklistProductDetail[] } ChecklistProductList
 */

/**
 * 方案清单线材详情类型定义
 *
 * **接口文档** 黄冰洋<huangbingyang@lysoratech.com>
 *
 * [方案清单](https://enetdevtest.rj.link/api/v1/schemes/doc.html#/default/%E6%96%B9%E6%A1%88%E7%AB%A0%E8%8A%82/getSectionUsingGET) - https://enetdevtest.rj.link/api/v1/schemes/doc.html#/default/%E6%96%B9%E6%A1%88%E7%AB%A0%E8%8A%82/getSectionUsingGET
 *
 * @typedef { object } ChecklistWireDetail
 * @property { number } addMethod 添加方式（目前值等未知）
 * @property { string } brandName 品牌名称，如 **Lysora**
 * @property { number } boxCount 多少箱，可通过计算 `prodCountView/unitCount` 得出实际多少与 `boxCount` 比较是否发生调整
 * @property { number } catId 产品分类ID
 * @property { string } catName 产品分类名称
 * @property { string } catTag 产品分类英文Tag，如 `electric_wire` 标识电缆，`fiber_wire` 标识光缆
 * @property { number } costPrice 产品成本价
 * @property { number } devicePosition
 * @property { number } deviceVisible
 * @property { number } id 产品列表唯一标识ID（**注：不是产品型号ID，产品型号ID请使用 `prodID` 字段**）
 * @property { boolean } isWire 是否线材，目前普通产品和线材分开返回，所以线材该字段固定 `isWire`
 * @property { string } notes 备注
 * @property { number } originalCostPrice
 * @property { number } originalProdPrice
 * @property { number } prodCount 线材总长度（注意不是多少箱，也要注意单位换算，如米换算英尺）
 * @property { number } prodCountView 线材总长度
 * @property { string } prodDescp 线材说明
 * @property { number } prodId 线材ID（**注：和 `id` 字段的区别**）
 * @property { string } prodIntro 线材简介
 * @property { string } prodKey
 * @property { string } prodName 线材名称
 * @property { number } prodPrice
 * @property { string } prodSource 线材来源，如 `lysora`，标识为Lysora产品
 * @property { string } prodUnit 线材单位，如 `台`
 * @property { string } productSource 产品型号来源，如 `lysora`，标识为Lysora产品
 * @property { string } resourseUrl 来源图标链接地址
 * @property { string | number } schemeId 产品归属方案ID
 * @property { number } schemeProdOrder
 * @property { string } typeName 产品Tag
 * @property { number } unitCount 线材单位长度（如每箱多少米）
 * @property { number } userProdCount
 */

/**
 * 方案清单线材列表类型定义
 *
 * **接口文档** 黄冰洋<huangbingyang@lysoratech.com>
 *
 * [方案清单](https://enetdevtest.rj.link/api/v1/schemes/doc.html#/default/%E6%96%B9%E6%A1%88%E7%AB%A0%E8%8A%82/getSectionUsingGET) - https://enetdevtest.rj.link/api/v1/schemes/doc.html#/default/%E6%96%B9%E6%A1%88%E7%AB%A0%E8%8A%82/getSectionUsingGET
 *
 * @typedef { ChecklistWireDetail[] } ChecklistWireList
 */

/**
 * 方案清单楼层详情类型定义
 *
 * **接口文档** 黄冰洋<huangbingyang@lysoratech.com>
 *
 * [方案清单](https://enetdevtest.rj.link/api/v1/schemes/doc.html#/default/%E6%96%B9%E6%A1%88%E7%AB%A0%E8%8A%82/getSectionUsingGET) - https://enetdevtest.rj.link/api/v1/schemes/doc.html#/default/%E6%96%B9%E6%A1%88%E7%AB%A0%E8%8A%82/getSectionUsingGET
 *
 * @typedef { object } ChecklistFloorDetail
 * @property { object } planInfo 方案信息
 * @property { number } planInfo.bgRotate
 * @property { number } planInfo.scale
 * @property { string } planInfo.sourceBgUrl 方案图片链接地址
 * @property { number } realFloor 真实楼层数
 * @property { string | number } regionId 楼层ID
 * @property { string } regionName 楼层名称
 * @property { ChecklistProductList } regionProds 楼层关联的产品列表
 * @property { string } regionType 楼层类型（暂不清楚用处）
 */

/**
 * 方案清单线材列表类型定义
 *
 * **接口文档** 黄冰洋<huangbingyang@lysoratech.com>
 *
 * [方案清单](https://enetdevtest.rj.link/api/v1/schemes/doc.html#/default/%E6%96%B9%E6%A1%88%E7%AB%A0%E8%8A%82/getSectionUsingGET) - https://enetdevtest.rj.link/api/v1/schemes/doc.html#/default/%E6%96%B9%E6%A1%88%E7%AB%A0%E8%8A%82/getSectionUsingGET
 *
 * @typedef { ChecklistFloorDetail[] } ChecklistFloorList
 */

/**
 * 方案清单线材列表类型定义
 *
 * **接口文档** 黄冰洋<huangbingyang@lysoratech.com>
 *
 * [方案清单](https://enetdevtest.rj.link/api/v1/schemes/doc.html#/default/%E6%96%B9%E6%A1%88%E7%AB%A0%E8%8A%82/getSectionUsingGET) - https://enetdevtest.rj.link/api/v1/schemes/doc.html#/default/%E6%96%B9%E6%A1%88%E7%AB%A0%E8%8A%82/getSectionUsingGET
 *
 * @typedef { ChecklistWireDetail[] } ChecklistWireList
 */

/**
 * 方案清单设备详情类型定义
 *
 * **接口文档** 黄冰洋<huangbingyang@lysoratech.com>
 *
 * [方案清单](https://enetdevtest.rj.link/api/v1/schemes/doc.html#/default/%E6%96%B9%E6%A1%88%E7%AB%A0%E8%8A%82/getSectionUsingGET) - https://enetdevtest.rj.link/api/v1/schemes/doc.html#/default/%E6%96%B9%E6%A1%88%E7%AB%A0%E8%8A%82/getSectionUsingGET
 *
 * @typedef { object } ChecklistDeviceDetail
 * @property { string } deviceName 设备备注信息
 * @property { number } devicePosition 设备点位信息，旧版字段，新版使用 `position` 字段判断设备是否包含点位信息
 * @property { number } deviceVisible
 * @property { number } id 设备Id
 * @property { object } planInfo 方案信息
 * @property { number } planInfo.bgRotate
 * @property { number } planInfo.scale
 * @property { string } planInfo.sourceBgUrl 方案图片链接地址
 * @property { object } [position] 设备点位信息
 * @property { object } [locationDms] 设备经纬度（带符号和单位），海外云地勘网桥地勘场景返回
 * @property { string } [location.lngDms] 设备经纬度
 * @property { string } [location.latDms] 设备经纬度
 * @property { object } [location] 设备经纬度），海外云地勘网桥地勘场景返回
 * @property { number } [location.lng] 设备经纬度
 * @property { number } [location.lat] 设备经纬度
 * @property { number | string } regionId 设备关联楼层ID
 * @property { string } regionName 设备关联楼层名称
 * @property { 'bridge' } regionType 设备布点类型，`bridge` 表示海外网桥地勘场景添加布点的设备
 * @property { 'cpe' | 'ap' | 'site' } role 设备点位类型，`cpe` - cpe设备，`ap` - ap设备，`site`
 */

/**
 * 方案清单设备列表类型定义
 *
 * **接口文档** 黄冰洋<huangbingyang@lysoratech.com>
 *
 * [方案清单](https://enetdevtest.rj.link/api/v1/schemes/doc.html#/default/%E6%96%B9%E6%A1%88%E7%AB%A0%E8%8A%82/getSectionUsingGET) - https://enetdevtest.rj.link/api/v1/schemes/doc.html#/default/%E6%96%B9%E6%A1%88%E7%AB%A0%E8%8A%82/getSectionUsingGET
 *
 * @typedef { ChecklistDeviceDetail[] } ChecklistDeviceList
 */

/**
 * 编辑产品清单产品信息参数类型定义
 *
 * **接口文档** 黄冰洋<huangbingyang@lysoratech.com>
 *
 * [方案清单](https://enetdevtest.rj.link/api/v1/schemes/doc.html#/default/%E6%96%B9%E6%A1%88%E7%AB%A0%E8%8A%82/getSectionUsingGET) - https://enetdevtest.rj.link/api/v1/schemes/doc.html#/default/%E6%96%B9%E6%A1%88%E7%AB%A0%E8%8A%82/getSectionUsingGET
 *
 * @typedef { object } ChecklistProductParams
 * @property { number | string } schemeId 方案ID
 * @property { number | string } id 产品ID
 * @property { string } brandName 品牌
 * @property { string } catName 产品类型
 * @property { string } [prodDescp] 产品说明
 */

export {};

/**
 * 更新线材数量（支持批量）
 *
 * **接口文档**
 * @author 黄冰洋<huangbingyang@lysoratech.com>
 * @see https://enetdevtest.rj.link/api/v1/schemes/doc.html#/default/%E6%96%B9%E6%A1%88%E4%BA%A7%E5%93%81/updatePriceUsingPOST_2
 *
 * @param { object } params - 请求参数
 * @param  { number } params.schemeId - 方案ID
 * @param  { object[] } params.schemeProds - 线材列表
 * @param  { number } params.schemeProds[].schemeProdId - 线材ID
 * @param  { number } params.schemeProds[].boxCount - 多少箱
 * @param  { number } params.schemeProds[].unitCount - 一箱多少米（后端存的是米，需要自行转换）
 * @returns { Promise }
 */
export const requestUpdateChecklistWireConfig = async params => {
  const result = await requestHttp({
    api: `${SERVER}/scheme/prod/wire/update`,
    method: 'POST',
    module: 'schemes',
    params
  });

  if (result.code === 0) {
    return result.data;
  } else {
    return Promise.reject(result);
  }
};

/**
 * 更新线材数量（支持批量）
 *
 * **接口文档**
 * @author 黄冰洋<huangbingyang@lysoratech.com>
 * @see https://enetdevtest.rj.link/api/v1/schemes/doc.html#/default/%E6%96%B9%E6%A1%88%E4%BA%A7%E5%93%81/updatePriceUsingPOST_1
 *
 * @param { object } params - 请求参数
 * @param  { number } params.schemeId - 方案ID
 * @param  { number } [params.schemeProdId] - 线材ID，未传时重置当前方案清单所有线材数量
 * @returns { Promise }
 */
export const requestResetWireQuantity = async params => {
  const result = await requestHttp({
    api: `${SERVER}/scheme/prod/wire/reset`,
    method: 'POST',
    module: 'schemes',
    params
  });

  if (result.code === 0) {
    return result.data;
  } else {
    return Promise.reject(result);
  }
};

/**
 * 重置产品清单排序
 *
 * **接口文档**
 * @author 黄冰洋<huangbingyang@lysoratech.com>
 * @see https://enetdevtest.rj.link/api/v1/schemes/doc.html#/default/%E6%96%B9%E6%A1%88%E4%BA%A7%E5%93%81/sortUsingPOST_1
 *
 * @param { object } params - 请求参数
 * @param  { number } params.schemeId - 方案ID
 * @param  { 0 | 1 } params.type - 重置哪个视图排序
 *
 * - 0 - **按设备查看** 排序重置
 * - 1 - **按楼层查看** 排序重置
 *
 * @returns { Promise }
 */
export const requestChecklistSortReset = async params => {
  const result = await requestHttp({
    api: `${SERVER}/scheme/prod/sort/reset`,
    method: 'POST',
    module: 'schemes',
    params
  });

  if (result.code === 0) {
    return result.data;
  } else {
    return Promise.reject(result);
  }
};

/**
 * 请求产品清单
 *
 * **接口文档**
 * @author 黄冰洋<huangbingyang@lysoratech.com>
 * @see https://lysoratech-enet-test.rj.link:6443/api/v1/schemes/doc.html#/default/%E6%96%B9%E6%A1%88%E7%AB%A0%E8%8A%82/getSectionUsingGET
 *
 * @param { object } params
 * @param { number | string } params.schemeId 方案ID
 * @param { 0 | 1 } params.showProdType 0 - 按设备查看 | 1 - 按楼层查看
 * @returns { Promise<ChecklistDetail> } 返回我创建和我接收方案数据统计
 */
export const requestChecklistDetail = async params => {
  const result = await requestHttp({
    api: `${SERVER}/scheme/section/prod/list`,
    method: 'GET',
    module: 'schemes',
    querys: params
  });

  if (result.code === 0) {
    return result.data;
  } else {
    return Promise.reject(result);
  }
};

/**
 * 批量更新方案清单产品信息（目前主要用于批量更新产品数量）
 *
 * **接口文档**
 * @author 黄冰洋<huangbingyang@lysoratech.com>
 * @see https://lysoratech-enet-test.rj.link:6443/api/v1/schemes/doc.html#/default/%E6%96%B9%E6%A1%88%E4%BA%A7%E5%93%81/updateBatchUsingPOST
 *
 * @param { object } params - 请求参数
 * @param { string ｜ number } params.schemeId - 方案ID
 * @param { object[] } params.updateProds - 产品列表
 * @param { string ｜ number } params.updateProds.id - 产品ID
 * @param { number } params.updateProds.prodCount - 产品数量
 * @returns { Promise<void> }
 */
export const requestUpdateChecklistProductInfo = async params => {
  const result = await requestHttp({
    api: `${SERVER}/scheme/prod/update/batch`,
    method: 'POST',
    module: 'schemes',
    params
  });

  if (result.code === 0) {
    return result.data;
  } else {
    return Promise.reject(result);
  }
};
